module.exports = __webpack_public_path__ + "static/media/24.06d4073d.mp3";